import { getItemFromCollection } from "directus/src/operations";

export async function fetchHolidayData({ holidayId }) {
  try {
    const response = await getItemFromCollection("holidays", holidayId);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
